var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.71H9.5V9.70996H13.5V8.70996H9.5V4.70996H8.5V8.70996H4.5V9.70996H8.5V13.71ZM9 18.21C7.75 18.21 6.575 17.9766 5.475 17.51C4.375 17.0433 3.421 16.406 2.613 15.598C1.80433 14.7893 1.16667 13.835 0.7 12.735C0.233333 11.635 0 10.46 0 9.20996C0 7.95996 0.233333 6.78496 0.7 5.68496C1.16667 4.58496 1.80433 3.63063 2.613 2.82196C3.421 2.01396 4.375 1.37663 5.475 0.909961C6.575 0.443294 7.75 0.209961 9 0.209961C10.25 0.209961 11.425 0.443294 12.525 0.909961C13.625 1.37663 14.5793 2.01396 15.388 2.82196C16.196 3.63063 16.8333 4.58496 17.3 5.68496C17.7667 6.78496 18 7.95996 18 9.20996C18 10.46 17.7667 11.635 17.3 12.735C16.8333 13.835 16.196 14.7893 15.388 15.598C14.5793 16.406 13.625 17.0433 12.525 17.51C11.425 17.9766 10.25 18.21 9 18.21ZM9 17.21C11.2167 17.21 13.1043 16.431 14.663 14.873C16.221 13.3143 17 11.4266 17 9.20996C17 6.99329 16.221 5.10563 14.663 3.54696C13.1043 1.98896 11.2167 1.20996 9 1.20996C6.78333 1.20996 4.896 1.98896 3.338 3.54696C1.77933 5.10563 1 6.99329 1 9.20996C1 11.4266 1.77933 13.3143 3.338 14.873C4.896 16.431 6.78333 17.21 9 17.21Z",
    fill: "#0A7CC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.8084d3223f71650f595822021b895d48.svg";
export { ForwardRef as ReactComponent };